(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[341],{

/***/ 25376:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/olvido-contrasena",
      function () {
        return __webpack_require__(41277);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



const baseStyles = {
    solid: "inline-flex justify-center rounded-lg py-2 px-3 text-sm font-semibold outline-2 outline-offset-2 transition-colors",
    outline: "inline-flex justify-center rounded-lg border py-[calc(theme(spacing.2)-1px)] px-[calc(theme(spacing.3)-1px)] text-sm outline-2 outline-offset-2 transition-colors"
};
const variantStyles = {
    solid: {
        primary: "relative overflow-hidden bg-primary text-white before:absolute before:inset-0 active:before:bg-transparent hover:before:bg-white/10 active:bg-primary/90 active:text-white/80 before:transition-colors",
        secondary: "bg-secondary text-white hover:bg-secondary/90 active:bg-secondary/90 active:text-white/70",
        white: "bg-white text-cyan-900 hover:bg-white/90 active:bg-white/90 active:text-cyan-900/70",
        disabled: "bg-gray-200 text-gray-500 cursor-not-allowed"
    },
    outline: {
        primary: "border-primary text-gray-900 hover:border-gray-400 active:bg-gray-100 active:text-gray-700/80",
        disabled: "border-gray-200 text-gray-500 cursor-not-allowed"
    }
};
const variantSize = {
    sm: "px-2.5 py-1.5 text-xs font-medium",
    md: "px-3 py-2 text-sm font-medium leading-4",
    lg: "px-4 py-2 text-sm font-medium",
    xl: "px-4 py-2 text-base font-medium",
    "2xl": "px-6 py-3 text-base font-medium"
};
const Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { variant ="solid" , color ="primary" , size ="lg" , className , block =false , loading =false , ...rest } = param;
    const classes = (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(baseStyles[variant], variantStyles[variant][color], variantSize[size], className, {
        "w-full": block
    });
    if (loading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classes,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "flex animate-pulse space-x-2 py-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-2 w-2 rounded-full bg-white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-2 w-2 rounded-full bg-white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-2 w-2 rounded-full bg-white"
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        ref: ref,
        className: classes,
        ...rest
    });
});
Button.displayName = "Button";
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 58281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const Label = (param)=>{
    let { id , children , required  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        htmlFor: id,
        className: "mb-2 block text-sm font-semibold text-gray-900",
        children: [
            children,
            required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "ml-1 text-solid-red",
                children: "*"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Label);


/***/ }),

/***/ 89381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hookform_error_message__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32866);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87536);
/* harmony import */ var _Label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58281);






const TextField = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef((param, ref)=>{
    let { label , name , description , id , initialValue , disabled , handleChange , value , reference , className , required , ...rest } = param;
    const { setValue , formState: { errors  }  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .useFormContext */ .Gc)();
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(()=>{
        setValue(name, initialValue);
    }, [
        initialValue
    ]);
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(()=>{
        value && setValue(name, value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full",
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Label__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                id: name,
                required: required,
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    id: id,
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('sm:leading-6" block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm', {
                        "cursor-not-allowed bg-gray-100": disabled
                    }, className),
                    name: name,
                    disabled: disabled,
                    ref: ref,
                    onChange: handleChange || undefined,
                    value: value,
                    autoComplete: "off",
                    ...rest
                })
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-sm text-gray-500",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hookform_error_message__WEBPACK_IMPORTED_MODULE_5__/* .ErrorMessage */ .B, {
                errors: errors,
                name: name,
                render: (param)=>/*#__PURE__*/ {
                    let { message  } = param;
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "my-2 text-sm text-red-500",
                        children: message
                    });
                }
            })
        ]
    });
});
TextField.displayName = "TextField";
/* harmony default export */ __webpack_exports__["Z"] = (TextField);


/***/ }),

/***/ 56438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


const SeoHead = (props)=>{
    const { seo  } = props;
    const { canonicalUrl  } = seo;
    const twitter = seo.socials.find((social)=>social.network === "twitter");
    const facebook = seo.socials.find((social)=>social.network === "facebook");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: seo.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: seo.description
            }),
            facebook && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: facebook.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: facebook.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: seo.canonicalUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "".concat(facebook.image.data.attributes.url)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:width",
                        content: "1200"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:height",
                        content: "630"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Codealo"
                    })
                ]
            }),
            twitter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: twitter.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: twitter.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "".concat(twitter.image.data.attributes.url)
                    })
                ]
            }),
            canonicalUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: seo.robots
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoHead);


/***/ }),

/***/ 60699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _atoms_SeoHead__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56438);
/* harmony import */ var _organisms_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35604);
/* harmony import */ var _organisms_Header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58620);





const DefaultLayout = (param)=>{
    let { seo , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_SeoHead__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                seo: seo
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex min-h-screen flex-col",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_organisms_Header__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                        className: "flex-1",
                        children: children
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_organisms_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultLayout);


/***/ }),

/***/ 42008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ SEO_DEFAULT; }
/* harmony export */ });
const SEO_DEFAULT = {
    id: 0,
    title: "Codealo",
    description: "La mejor comunidad de programadores en Latino Am\xe9rica",
    robots: "noindex",
    canonicalUrl: "https://codealo.dev",
    image: undefined,
    socials: []
};


/***/ }),

/***/ 41277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(60699);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./src/components/atoms/Button/index.tsx
var Button = __webpack_require__(91468);
// EXTERNAL MODULE: ./src/components/atoms/Form/TextField.tsx
var TextField = __webpack_require__(89381);
// EXTERNAL MODULE: ./src/services/AuthService.ts
var AuthService = __webpack_require__(66918);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var yup_index_esm = __webpack_require__(16310);
;// CONCATENATED MODULE: ./src/components/organisms/Forms/ForgotPassword.tsx









const schema = yup_index_esm/* object */.Ry().shape({
    email: yup_index_esm/* string */.Z_().email("Correo electr\xf3nico inv\xe1lido").required("Correo electr\xf3nico es requerido")
});
const ForgotPassword = ()=>{
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const resolver = (0,yup/* yupResolver */.X)(schema);
    const methods = (0,index_esm/* useForm */.cI)({
        resolver
    });
    const { register , handleSubmit  } = methods;
    const onSubmit = handleSubmit(async (data)=>{
        try {
            setIsLoading(true);
            const response = await AuthService/* default.forgotPassword */.Z.forgotPassword(data.email);
            dist/* toast.success */.Am.success("Se ha enviado un correo para restablecer la contrase\xf1a", {
                duration: 5000
            });
        } catch (err) {
            dist/* toast.error */.Am.error("Error recuperando contrase\xf1a");
        } finally{
            setIsLoading(false);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, {
        ...methods,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            onSubmit: onSubmit,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        ...register("email"),
                        name: "email",
                        id: "email",
                        label: "Email",
                        placeholder: "codealo@example.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onSubmit,
                        variant: "solid",
                        color: "primary",
                        size: "lg",
                        type: "submit",
                        block: true,
                        loading: isLoading,
                        children: "Restablecer Contrase\xf1a"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Forms_ForgotPassword = (ForgotPassword);

// EXTERNAL MODULE: ./src/constants/SeoDefault.ts
var SeoDefault = __webpack_require__(42008);
;// CONCATENATED MODULE: ./src/components/views/Security/ForgotPassword.tsx




const ForgotPasswordView = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayout/* default */.Z, {
        seo: SeoDefault/* SEO_DEFAULT */.C,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex min-h-full items-center justify-center px-4 py-12 sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full max-w-md space-y-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "mt-6 text-center text-3xl font-bold tracking-tight text-gray-900",
                            children: "Restablecer Contrase\xf1a"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-8 sm:mx-auto sm:w-full sm:max-w-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-4 text-gray-700",
                                    children: "Te enviaremos un email con las instrucciones para restablecer tu contrase\xf1a"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms_ForgotPassword, {})
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Security_ForgotPassword = (ForgotPasswordView);

;// CONCATENATED MODULE: ./src/pages/auth/olvido-contrasena.tsx


function Index() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Security_ForgotPassword, {});
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,2552,9842,3044,9746,9774,2888,179], function() { return __webpack_exec__(25376); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);